
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../api/client';

// Thunk to fetch player history with optional filters
export const fetchPlayerHistory = createAsyncThunk(
  'playerHistory/fetch',
  async ({ userId, dateFilter, gameFilter }, { rejectWithValue }) => {
    try {
      let url = `/user-history/${userId}`;
      const params = new URLSearchParams();

      if (dateFilter) params.append('date', dateFilter);
      if (gameFilter && gameFilter !== 'All') params.append('game', gameFilter);

      if (params.toString()) url += `?${params.toString()}`;

      const res = await api.get(url);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: 'Failed to fetch player history' });
    }
  }
);

const playerHistorySlice = createSlice({
  name: 'playerHistory',
  initialState: {
    records: [],
    total: 0,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlayerHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPlayerHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.records = action.payload.records || [];
        state.total = action.payload.total || 0;
      })
      .addCase(fetchPlayerHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to fetch';
      });
  },
});

export default playerHistorySlice.reducer;
